//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "FooterComponent",
  props: {
    bootstrap: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      email: null,
      panel: null,
      categories: [],
      success: null,
      error: null,
    }
  },
  computed: {
    socialMenu() {
      return this.$store.getters.getBootstrap?.data?.menu?.socials?.items;
    },
    showBottomSection() {
      return this.$store.getters.getShowBottomSection
    }
  },
  methods: {
    footerAlign() {
      if (document.querySelector('#footer')) {
        document.querySelector('#footer').style.display = 'block';
        document.querySelector('#footer').style.height = 'auto';
        const footerHeight = document.querySelector('#footer')?.clientHeight || 0;
        if (!this.$route.path.includes('/checkout') && !this.$route.path.includes('/thank-you') && !this.$route.path.includes('/profile')) {
          document.querySelector('.v-main__wrap').style.paddingBottom = `${footerHeight}px`;
        } else {
          document.querySelector('.v-main__wrap').style.paddingBottom = `0px`;
          document.querySelector('#footer').style.height = '0px';
        }
        // document.querySelector('#footer').style.paddingBottom = `${footerHeight}px`;
      } else {
        document.querySelector('.v-main__wrap').style.paddingBottom = `0px`;
      }
    },
    hideBottomSection() {
      this.$store.commit('setLocalVar', {var: 'showBottomSection', val: false});
      this.$nextTick(() => {
        this.footerAlign();
      })
    },
    subscribe() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return false;
        } else {
          this.success = null;
          this.error = null;
          const params = {
            email: (this.email).toLowerCase()
          }
          this.$axios.post('/subscribe', params)
            .then(res => {
              fbq('track', 'Lead');
              this.email = null;
              this.success = this.$t('success');
              this.$refs.form.reset();
              setTimeout(() => {
                this.success = null;
              }, 5000)
            })
          .catch(err => {
            this.error = err.response.data.errors[0].message;
            setTimeout(() => {
              this.error = null;
            }, 5000)
          })
        }
      })
    },
  },
  beforeMount() {
    this.categories = this.bootstrap.data.menu.footer.items.filter(item => !item.parent_id);
    this.categories.map(item => {
      item.subs = this.bootstrap.data.menu.footer.items.filter(i => i.parent_id === item.id);
      return item
    })
  },
  mounted() {
    /*if (this.bootstrap) {
      this.footerAlign();
    }
    $(window).resize(function () {
      if (this.bootstrap) {
        this.footerAlign();
      }
    });*/
  }
}
